import * as cookies from './Cookies';
import * as authenticator from './Authenticator';
import * as apiWrapper from './APIWrapper';

/**
 * checkContract
 * @param {*} idToken
 * @param {*} callback
 */
export function checkContract(idToken, callback) {
  if (CONTRACT_API_URL.slice( -1 ) == "/"){
    var contractApiUrl = CONTRACT_API_URL.slice( 0, -1 ) + `${CONTRACT_API_PARAM}/${KTACS_SERVICE_ID}`;
  } else{
    var contractApiUrl = `${CONTRACT_API_URL}${CONTRACT_API_PARAM}/${KTACS_SERVICE_ID}`;
  }
  console.log('サービス契約チェックAPI');
  console.log('request url:' + contractApiUrl);
  const req = new XMLHttpRequest(); //API投げるためのオブジェクト
  req.open('GET', contractApiUrl, true);
  req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  req.setRequestHeader('authorization', 'Bearer ' + idToken);
  req.timeout = TIMEOUT;

  req.onerror = () => {
    console.log('response code:' + req.status);
    authenticator.deleteSessionCookie();
    postRequestErrors(req.status, req.responseText, contractApiUrl);
    callback(new Error(-1), null); // -1 (その他エラーコード) 
  };

  req.onload = () => {
    if (req.readyState === 4) {
      console.log('response code:' + req.status);
      if (req.status === 200) {
        sessionStorage.setItem('reAuthenticationCntOpenId', 0); // 正常終了時再認証カウントをクリアする
        cookies.removeItem('userName');
        const result = JSON.parse(req.responseText);
        console.log(result);
        // サービス契約有無チェック
        if(result.has_contract){
          // k-tacsが契約されていた場合
          cookies.setItem('id_token', idToken);
          cookies.setItem('userId', result.uid);
          cookies.setItem('userName', result.cn);
        } 
        else{ 
          // k-tacsが契約されていない場合
          authenticator.deleteSessionCookie();
          console.log('K-TACsの利用を許可されていません');
          location.replace(PORTAL_URL + '?contract_err=true&service_id=' + KTACS_SERVICE_ID);
          javascript_die();
        }

        if (!cookies.getItem('checkedNonce')){
          // nonceチェック
          const cookiesNonce = cookies.getItem('nonce');
          console.log('nonce(cookies):' + cookiesNonce);
          console.log('nonce(id_token):' + result.nonce);
          if (cookiesNonce != result.nonce){
            // nonceが一致しない場合
            console.log('nonce does not match');
            authenticator.deleteSessionCookie();
            location.replace(PORTAL_URL_END_SESSION + '?error_flg=1');
            javascript_die();
          } else {
            cookies.removeItem('nonce');
          }
        }

        cookies.setItem('checkedNonce', true);  // nonceチェック済みフラグ
        cookies.setItem('isLogin', true); // ログイン済みフラグ

        callback(null, JSON.parse(req.responseText));

      } else if (req.status === 400 || req.status === 401) {

        let reAuthCnt = Number(sessionStorage.getItem('reAuthenticationCntOpenId'));
        let nowTransition = Boolean(sessionStorage.getItem('nowTransition'));

        if (isNaN(reAuthCnt)) reAuthCnt = 0;
        if (isNaN(nowTransition)) nowTransition = false;
//        if (nowTransition) return null;

        if (reAuthCnt < MAX_RE_AUTHENTICATION_CNT) {
          reAuthCnt += 1;
          sessionStorage.setItem('reAuthenticationCntOpenId', reAuthCnt);
          sessionStorage.setItem('recoverLastSearch', true);
          sessionStorage.setItem('nowTransition', true);
          cookies.removeItem('checkedNonce');
          console.log('authenticate again');
          authenticator.authorize();
          return null;
        } else {
          if (req.status === 400) {
            // エラーコード400の場合
            if (cookies.getItem('isLogin')) {
              console.log('error_code 400:通常アクセス');
              // 通常アクセス時のエラー処理
              authenticator.deleteSessionCookie();
              location.replace(PORTAL_URL_END_SESSION + '?error_flg=1');
              javascript_die();
            } else {
              console.log('error_code 400:初回ログイン');
              // 初回ログイン時のエラー処理
              authenticator.deleteSessionCookie();
              postRequestErrors(req.status, req.responseText, contractApiUrl);
              callback(new Error(400), null); // Unauthorized
            }
          } else {
            console.log('error_code 401');
            // エラーコード401の場合
            authenticator.deleteSessionCookie();
            location.replace(PORTAL_URL_END_SESSION + '?error_flg=1');
            javascript_die();
          }
        }
      } else if (req.status === 503) {
        console.log('メンテナンス中');
        callback(new Error(503), null);
      } else {
        console.log('その他エラー');
        authenticator.deleteSessionCookie();
        postRequestErrors(req.status, req.responseText, contractApiUrl);
        callback(new Error(-1), null); // -1 (上記以外のエラーコード)
      }
    }
  };

  req.ontimeout = () => {
    authenticator.deleteSessionCookie();
    postRequestErrors(req.status, req.responseText, contractApiUrl);
    callback(new Error(408), null); // XMLHttpRequest timed out. Do something here.
  };

  req.onabort = () => {
    authenticator.deleteSessionCookie();
    postRequestErrors(req.status, req.responseText, contractApiUrl);
    callback(new Error(-1), null);
  };

  req.send();
}

/**
 * subscribe
 */
export function postRequestErrors(status, body, url) {
  apiWrapper.postRequestErrors(status, body, url);
}

